<template>
  <zpa-form-item
    :error="error"
    :success="success"
    :validating="validating"
    :required="required"
    :readonly="$readonly"
    :disabled="disabled"
    :uuid="uuid"
    :span="span"
    :push="push"
    :pull="pull"
    :label="label"
    :labelWidth="labelWidth"
    :labelAlign="labelAlign"
    :itemHeight="itemHeight"
  >
    <i-input
      :type="passwordType"
      :value="valueFmt"
      :placeholder="placeholder || label"
      :readonly="$readonly"
      :disabled="disabled"
      :clearable="$readonly === true ? false : clearable"
      :size="$size"
      :maxlength="len"
      :password="password"
      @on-change="onInputChange"
    >
      <Icon v-if="type && type!== 'rules'" :type="`ios-${type}`" slot="suffix"></Icon>
      <Icon
        v-else-if="type==='rules'"
        type="md-add"
        size="24"
        slot="suffix"
        style="cursor: pointer;"
        @click="onSend($event, value)"
      ></Icon>
    </i-input>
  </zpa-form-item>
</template>

<script>
import inputMixin from './mixins/input'

export default {
  name: 'zpaTextInput',

  mixins: [inputMixin],

  data() {
    return {
      formViewModalStatus: false,
    }
  },

  computed: {
    passwordType() {
      return this.password ? 'password' : undefined
    },
  },

  props: {
    type: [String, Number],

    placeholder: [String, Number],

    isTrim: Boolean,

    needButton: Boolean,

    isRender: Boolean,

    isPreview: Boolean,

    item: Object,

    password: Boolean,
  },

  methods: {
    saveAccess(item, access) {
      this.$set(item, 'access', access)
    },
  },
}
</script>
